import SupplementCropReplicate from "./SupplementCropReplicate";
import O from "./O";

import { useStore } from 'react-redux';
import { useState } from 'react';
import DemoGels from './DemoGels';
import useToggle from './useToggle';

const labelLinkMap = {
  NAGK:"https://www.uniprot.org/uniprotkb/Q9UJ70/entry",
  RIPK2:"https://www.uniprot.org/uniprotkb/E7ERW9/entry",
  "β-actin":"https://www.uniprot.org/uniprotkb/G8FSY7/entry",
  "p-IκBα":"https://www.uniprot.org/uniprotkb/Q9UGJ8/entry",
  "p38":"",
  "p65":"",
}


function getMembrane(imageSetId){

  return Object.keys(DemoGels).find(key => {
    return DemoGels[key].flat().includes(imageSetId)
  })


}

export function getMembranePercentWidth(gels){

  let numStripReprobes = gels.map(gelId => DemoGels[gelId].map(reprobes => reprobes.length)).flat();
  let maxStripReprobes = Math.max(...numStripReprobes);
  return Math.min(50,Number((100/maxStripReprobes).toFixed(0))) + '%';

}

export default function SupplementReplicateContainer({
  selectedLabel,
  onEvent,

}){


  let store = useStore();
  let state = store.getState();

  const [ show, toggleGelInfo, setShow ] = useToggle(false);

  let atnsWithLabel = Object.values(state.data.annotations).filter(x => x.label === selectedLabel);
  let imageSetIds = atnsWithLabel.map(x => x.imageSetId);
  let gels = imageSetIds.map(getMembrane);

  let maxMembraneWidth = show ? getMembranePercentWidth(gels) : '50%';

  return (
    <div 
      style={{
      margin:20,
      //marginTop:10,
      minHeight:0}} class="sg-col full-height rel">



      <div style={{marginRight:5}} class="sg-row h-center">
        <div style={{fontSize:24}}>
            <a href={labelLinkMap[selectedLabel]} target="_blank;">
              {selectedLabel}
            </a>
          </div>
      </div>


      <div style={{
        justifyContent:'flex-end',
        //transform:'translate(0,-50%)',
        fontSize:16
      }} class="sg-row v-center">
      <div>Expand Layout</div> &nbsp; {toggleGelInfo}
      </div>



      <div key={"hello-"+show} style={{
        minHeight:0, 
        overflowY:'scroll',

      }} class="sg-col flex-expand rel">
        {gels.map((g,ii) => {
          return (
            <div style={{marginBottom:50}}>
              <div class="bold" style={{fontSize:24}}>{"Replicate " + (ii+1)}</div>
              <SupplementCropReplicate 
                onEvent={onEvent} 
                maxMembraneWidth={maxMembraneWidth}
                membrane={g} 
                toHighlight={imageSetIds}
                expandMembrane={show}
              /> 
            </div>
          )
        })}
      </div>
    </div>
  )



}
